import { GrpcWebFetchTransport } from '@protobuf-ts/grpcweb-transport';
import { RpcOptions, UnaryCall } from '@protobuf-ts/runtime-rpc';
import { APP_NAME, HOST, LANG } from '@/api/grpc-constants.ts';

export const GrpcWebTransport = new GrpcWebFetchTransport({
  baseUrl: HOST,
  fetchInit: { credentials: 'include' },
  format: 'binary',
  interceptors: [
    {
      // adds auth header to unary requests
      interceptUnary(next, method, input, options: RpcOptions): UnaryCall {
        if (!options.meta) {
          options.meta = {};
        }
        if (window.location.search.includes('debug')) {next(method, input, options).then((response) => {
            console.log('GrpcWebTransport.interceptUnary response', response);
          });
        }
        options.meta['x-application'] = APP_NAME;
        options.meta['x-app-locale'] = LANG;

        return next(method, input, options);
      },
    },
  ],
});
